export enum eIntegrationType {
  MESSENGER = 'MESSENGER',
  INSTAGRAM = 'INSTAGRAM',
  WHATSAPP_WEB = 'WHATSAPP_WEB',
  WHATSAPP_API = 'WHATSAPP_API',
  TIKTOK = 'TIKTOK',
}

export enum eIntegrationStatus {
  NO_ACCOUNT = 'NO_ACCOUNT',
  ACCOUNT_CREATED = 'ACCOUNT_CREATED',
  CONNECTION_REQUEST = 'CONNECTION_REQUEST',
  AUTH_REQUESTED = 'AUTH_REQUESTED',
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  BANNED = 'BANNED',
  DISCONNECTED = 'DISCONNECTED',
  /**
   * INT-1516 — WhatsApp API only. The account record exists, but Meta has not
   * activated the number on the Cloud API yet (WBS `pending_activation` or
   * `activating`, and any activation value bff-web does not recognize). Not
   * connected: messages do not arrive until it turns CONNECTED. `reason`
   * carries WBS `activation_reason` verbatim.
   */
  ACTIVATION_PENDING = 'ACTIVATION_PENDING',
  /**
   * INT-1516 — WhatsApp API only. Meta did not activate the number within the
   * activation window; the customer has to reconnect. `reason` carries WBS
   * `activation_reason` verbatim. The record can still heal into CONNECTED if
   * real traffic arrives for it.
   */
  ACTIVATION_FAILED = 'ACTIVATION_FAILED',
}
